import { BuildingPermitInteractor, BuildingPermitRequest, BuildingPermitStructRequest } from "../../Coordinator/BuildingPermit/BuildingPermitInteractor";

export class BuildingPermitViewModel {
    private interactor: BuildingPermitInteractor;

	constructor() {
		this.interactor = new BuildingPermitInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new BuildingPermitRequest(
            obj["sgepalvaraconstrucao"] ? parseInt(obj["sgepalvaraconstrucao"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new BuildingPermitStructRequest(
            obj["sgepalvaraconstrucao"] ? parseInt(obj["sgepalvaraconstrucao"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}